/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/theme.js":
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
/***/ (() => {

document.addEventListener("DOMContentLoaded", function () {
  var block_heading = document.querySelectorAll(".footer-block__heading");
  block_heading.forEach(function (item) {
    item.addEventListener("click", function (e) {
      if (item.parentElement.classList.contains("footer-active")) {
        item.parentElement.classList.remove("footer-active");
      } else {
        item.parentElement.classList.add("footer-active");
      }
    });
  });
  if (document.querySelectorAll('.product__accordion details')) {
    // Select all .product__accordion elements
    var accordions = document.querySelectorAll('.product__accordion details');

    // Function to close all accordions except the current one
    var closeAllExceptCurrent = function closeAllExceptCurrent(currentAccordion) {
      accordions.forEach(function (accordion) {
        if (accordion !== currentAccordion && accordion.open) {
          accordion.open = false;
        }
      });
    };

    // Add click event listener to each accordion
    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function (event) {
        // Close all other accordions
        closeAllExceptCurrent(this);
      });
    });
  }

  // if (document.querySelector('.utility-bar.color-scheme-1.gradient')){
  //     document.querySelector('.my-floating-cart').style.top = document.querySelector('.utility-bar.color-scheme-1.gradient').offsetHeight + 'px';
  // }

  // PDF Modal functionality
  var pdfModal = document.getElementById('pdf-modal');
  var pdfIframe = document.getElementById('pdf-iframe');
  var pdfModalClose = document.querySelector('.pdf-modal__close');
  var pdfModalOverlay = document.querySelector('.pdf-modal__overlay');

  // Function to open PDF modal
  function openPdfModal(pdfUrl) {
    if (pdfUrl && pdfUrl.trim() !== '') {
      // Set the PDF URL in the iframe
      pdfIframe.src = pdfUrl;
      // Show the modal
      pdfModal.style.display = 'flex';
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }
  }

  // Function to close PDF modal
  function closePdfModal() {
    // Hide the modal
    pdfModal.style.display = 'none';
    // Clear the iframe src to stop loading
    pdfIframe.src = '';
    // Restore body scroll
    document.body.style.overflow = 'auto';
  }

  // Add event listeners to elements with data-pdf attribute
  var pdfElements = document.querySelectorAll('[data-pdf]');
  pdfElements.forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      var pdfUrl = this.getAttribute('data-pdf');
      openPdfModal(pdfUrl);
    });
  });

  // Close modal when clicking the close button
  if (pdfModalClose) {
    pdfModalClose.addEventListener('click', closePdfModal);
  }

  // Close modal when clicking the overlay (outside the content)
  if (pdfModalOverlay) {
    pdfModalOverlay.addEventListener('click', function (e) {
      if (e.target === pdfModalOverlay) {
        closePdfModal();
      }
    });
  }

  // Close modal when pressing Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pdfModal.style.display === 'flex') {
      closePdfModal();
    }
  });
});

/***/ }),

/***/ "./src/assets/scss/cards-slider.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/cards-slider.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/pros-cons.scss":
/*!****************************************!*\
  !*** ./src/assets/scss/pros-cons.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/text-image-grid.scss":
/*!**********************************************!*\
  !*** ./src/assets/scss/text-image-grid.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/simple-image-slider.scss":
/*!**************************************************!*\
  !*** ./src/assets/scss/simple-image-slider.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/custom-contact-form.scss":
/*!**************************************************!*\
  !*** ./src/assets/scss/custom-contact-form.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/tabs-with-images.scss":
/*!***********************************************!*\
  !*** ./src/assets/scss/tabs-with-images.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/video-text-banner.scss":
/*!************************************************!*\
  !*** ./src/assets/scss/video-text-banner.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/dynamic-text-image-section.scss":
/*!*********************************************************!*\
  !*** ./src/assets/scss/dynamic-text-image-section.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/advantages.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/advantages.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/icons-grid.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/icons-grid.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/klaviyo-newsletter.scss":
/*!*************************************************!*\
  !*** ./src/assets/scss/klaviyo-newsletter.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/custom-image.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/custom-image.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/theme.scss":
/*!************************************!*\
  !*** ./src/assets/scss/theme.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/image-with-text-features.scss":
/*!*******************************************************!*\
  !*** ./src/assets/scss/image-with-text-features.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/image-with-text-features": 0,
/******/ 			"assets/theme": 0,
/******/ 			"assets/custom-image": 0,
/******/ 			"assets/klaviyo-newsletter": 0,
/******/ 			"assets/icons-grid": 0,
/******/ 			"assets/advantages": 0,
/******/ 			"assets/dynamic-text-image-section": 0,
/******/ 			"assets/video-text-banner": 0,
/******/ 			"assets/tabs-with-images": 0,
/******/ 			"assets/custom-contact-form": 0,
/******/ 			"assets/simple-image-slider": 0,
/******/ 			"assets/text-image-grid": 0,
/******/ 			"assets/pros-cons": 0,
/******/ 			"assets/cards-slider": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkdawn_tailwind_starter"] = self["webpackChunkdawn_tailwind_starter"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/js/theme.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/icons-grid.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/klaviyo-newsletter.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/custom-image.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/theme.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/image-with-text-features.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/cards-slider.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/pros-cons.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/text-image-grid.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/simple-image-slider.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/custom-contact-form.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/tabs-with-images.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/video-text-banner.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/dynamic-text-image-section.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/image-with-text-features","assets/theme","assets/custom-image","assets/klaviyo-newsletter","assets/icons-grid","assets/advantages","assets/dynamic-text-image-section","assets/video-text-banner","assets/tabs-with-images","assets/custom-contact-form","assets/simple-image-slider","assets/text-image-grid","assets/pros-cons","assets/cards-slider"], () => (__webpack_require__("./src/assets/scss/advantages.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;